import { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [utilisateur, setUtilisateur] = useState(null);
  const [token, setToken] = useState(null);
  const [chargement, setChargement] = useState(true);

  useEffect(() => {
    // Récupérer la session sauvegardée
    const tokenSauvegarde = localStorage.getItem('token');
    const utilisateurSauvegarde = localStorage.getItem('utilisateur');

    if (tokenSauvegarde && utilisateurSauvegarde) {
      setToken(tokenSauvegarde);
      setUtilisateur(JSON.parse(utilisateurSauvegarde));
    }
    setChargement(false);
  }, []);

  // Connexion
  const connecter = (tokenRecu, utilisateurRecu) => {
    localStorage.setItem('token', tokenRecu);
    localStorage.setItem('utilisateur', JSON.stringify(utilisateurRecu));
    setToken(tokenRecu);
    setUtilisateur(utilisateurRecu);
  };

  // Déconnexion
  const deconnecter = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('utilisateur');
    setToken(null);
    setUtilisateur(null);
  };

  return (
    <AuthContext.Provider value={{
      utilisateur, token, chargement,
      connecter, deconnecter,
      estConnecte: !!token
    }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);